import { INumberMaskParams } from "./number-mask-params";
import { createNumberMask } from 'text-mask-addons/dist/textMaskAddons';

export class InputMask {
  static getCodeMask(codeLength: number) {
    const codeMask = /[\w.\\/\\\\-]/;
    const strLength = codeLength;
    const mask: RegExp[] = [/[A-Za-z0-9]/];
    for (let i = 0; i < strLength - 1; i++) {
      mask.push(codeMask);
    }
    const maskModel = {
      mask,
      guide: false,
      keepCharPositions: true,
      placeholderChar: ' ',
    };
    return maskModel;
  }
  static getDecimalMask(params?: INumberMaskParams) {
    const mask = createNumberMask({
      prefix: params?.prefix ?? '',
      suffix: params?.suffix ?? '',
      allowDecimal: true,
      integerLimit: params?.integerLimit ?? 9,
      decimalLimit: params?.decimalLimit ?? 3,
      includeThousandsSeparator: params?.includeThousandsSeparator ?? false,
    });
    const maskModel = {
      mask,
      guide: false,
      keepCharPositions: true,
      placeholderChar: ' ',
    };
    return maskModel;
  }
  static getNumberMask(params?: INumberMaskParams) {
    const mask = createNumberMask({
      prefix: params?.prefix ?? '',
      suffix: params?.suffix ?? '',
      allowDecimal: false,
      integerLimit: params?.integerLimit ?? 8,
      includeThousandsSeparator: params?.includeThousandsSeparator ?? false,
    });
    const maskModel = {
      mask,
      guide: false,
      keepCharPositions: true,
      placeholderChar: ' ',
    };
    return maskModel;
  }
  static getCNICMask() {
    const codeMask = /[1-9]*\d/;
    const firstLength = 5;
    const mask = [];
    for (let i = 0; i < firstLength; i++) {
      mask.push(codeMask);
    }
    mask.push('-');
    const secondLength = 7;
    for (let i = 0; i < secondLength; i++) {
      mask.push(codeMask);
    }
    mask.push('-', codeMask);
    const maskModel = {
      mask,
      guide: false,
      keepCharPositions: true,
      placeholderChar: ' ',
    };
    return maskModel;
  }
}
